import StockOverview from "./StockOverview";

export default function InventoryReceipts() {
  return (
    <StockOverview
      title="Inventory Receipts"
      subtitle="Record delivered supplier shipments and review business receipt history from a dedicated receiving workspace."
      initialTab="receipts"
      lockedTab="receipts"
      showOpenWork={false}
      showAdjustAction={false}
      showReceiveAction
      historyTitle="Receipt History"
    />
  );
}
